import React from 'react';
import PropTypes from 'prop-types';

import { extractTextRuns, replaceTextRuns } from '../../../utils/emailTextRuns';

// Edit only the words inside a cell whose markup must not be touched.
//
// The case this exists for is a styled button:
//
//   <a href="…/pro-online" style="display:inline-block;background:#000000;…">Access</a>
//
// Six characters of copy inside four hundred of chrome. The rich text editor cannot open
// it — Tiptap keeps no inline style, so the button would lose its styling on the first
// save — but showing a copywriter the raw anchor to change one word is not an answer
// either. Here they get one field containing "Access", and the markup around it is never
// in the editor at all, so it cannot be damaged.
//
// Escaping and splicing live in src/utils/emailTextRuns.js where they are tested.

const EmailTextRunEditor = ({
  id, value, onChange, disabled,
}) => {
  const runs = extractTextRuns(value);

  const setRun = (index, text) => {
    const result = replaceTextRuns(value, { [index]: text });
    if (result.ok) onChange(result.html);
  };

  return (
    <div className="emails-runs">
      {runs.map(run => (
        <div className="emails-run" key={`${id}-run-${run.index}`}>
          <label htmlFor={`${id}-run-${run.index}`} className="emails-field-label">
            {runs.length > 1 ? `Text ${run.index + 1}` : 'Text'}
            <textarea
              id={`${id}-run-${run.index}`}
              className="emails-run-input"
              value={run.text}
              onChange={event => setRun(run.index, event.target.value)}
              disabled={disabled}
              rows={run.text.length > 90 ? 3 : 1}
            />
          </label>
        </div>
      ))}
      <p className="hint">
        {'You are editing the words only. The link, the colours and the spacing around '}
        {'them are left exactly as they are — they are not in this editor, so they '}
        {'cannot be broken here.'}
      </p>
    </div>
  );
};

EmailTextRunEditor.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

EmailTextRunEditor.defaultProps = {
  value: '',
  disabled: false,
};

export default EmailTextRunEditor;
